import {reqWithToken} from './requestHelper';

export async function getEmployeesWithKey(key){
    return (await reqWithToken('api/TeachersAndEmployees',{
        params:{
            key
        }
    })).data;
}
